module.exports = __webpack_public_path__ + "img/img9.0dff4809.svg";